import { defineComponent as _defineComponent } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const __default__ = require('@nuxtjs/composition-api').defineComponent({
  layout: 'default',
  head: {},
});

import { useMeta } from '@nuxtjs/composition-api';
import PasswordResetRequestForm from '~/components/member-settings/PasswordResetRequestForm.vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'password-reset-request',
  setup(__props) {

useMeta({
  title: 'Password Reset Request | Member',
  meta: [
    { hid: 'title', name: 'title', content: 'Password Reset | Member' },
    { hid: 'description', name: 'description', content: 'Edit School and Class Information' },
  ],
});

return { __sfc: true,PasswordResetRequestForm }
}

})